import { fromApi, toApi } from "./transformers"

const API_BASE = (import.meta.env.VITE_API_BASE_URL ?? "/api/v1").replace(/\/$/, "")

let unauthorizedHandler: (() => void) | null = null

export function registerUnauthorizedHandler(handler: (() => void) | null) {
  unauthorizedHandler = handler
}

export class ApiError extends Error {
  code: string
  status: number
  details?: unknown[]

  constructor(code: string, message: string, status: number, details?: unknown[]) {
    super(message)
    this.name = "ApiError"
    this.code = code
    this.status = status
    this.details = details
  }
}

export async function apiFetch<TResponse>(
  path: string,
  options: RequestInit & { rawBody?: unknown } = {},
): Promise<TResponse> {
  const token = localStorage.getItem("session_token")
  const headers = new Headers(options.headers ?? {})
  const isFormDataBody =
    typeof FormData !== "undefined" && options.body instanceof FormData

  if (!isFormDataBody) {
    headers.set("Content-Type", "application/json")
  }

  if (token) {
    headers.set("Authorization", `Bearer ${token}`)
  }

  const response = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers,
    body: options.rawBody !== undefined ? JSON.stringify(toApi(options.rawBody)) : options.body,
  })

  const isJson = response.headers.get("Content-Type")?.includes("application/json")
  const json = isJson ? fromApi<any>(await response.json()) : null

  if (!response.ok) {
    if (response.status === 401 && unauthorizedHandler) {
      unauthorizedHandler()
    }

    throw new ApiError(
      json?.error?.code ?? "UNKNOWN",
      json?.error?.message ?? "An unexpected error occurred.",
      response.status,
      json?.error?.details,
    )
  }

  return json as TResponse
}
